var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.567 2.11028L0.861816 3.24856V8.51486L6.56696 8.41885V2.11028M17.1381 9.75856L7.87242 9.59998V16.1494L17.1381 18V9.75856ZM6.567 9.58031L0.861856 9.48343V14.7489L6.567 15.888V9.58031ZM17.1381 0L7.87242 1.84885V8.39827L17.1381 8.24056V0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsFill);
export default __webpack_public_path__ + "static/media/windows-fill.b5ed4e5c1735c1fd4b6cf952511f9bb4.svg";
export { ForwardRef as ReactComponent };